module.exports = __webpack_public_path__ + "img/OBJECTS.b0b4fbc5.png";